import React, { useState, useCallback } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { renderContentFromMetadata } from '@jutro/uiconfig';
// import { EntryPageTemplate } from 'gw-components-platform-react';
import { Loader } from '@jutro/components';
import { useAuthentication } from 'gw-digital-auth-react';
import EntryPageTemplate from '../../customer/components/EntryPageTemplate/EntryPageTemplate';

import metadata from './EntryPage.metadata.json5';
import styles from './EntryPage.module.scss';
import './EntryPage.messages';

const VIEWS = {
    logInView: 'LOG_IN_VIEW',
    signUpView: 'SIGN_UP_VIEW',
    forgotPasswordView: 'FORGOT_PASSWORD_VIEW'
};

function EntryPage({ location }) {
    const { isAuthInProgress } = useAuthentication();
    const [view, updateView] = useState(VIEWS.logInView);
    const { state } = location;

    const handleForgotPasswordClick = useCallback(() => {
        updateView(VIEWS.forgotPasswordView);
    }, []);

    const handleSignUpClick = useCallback(() => {
        updateView(VIEWS.signUpView);
    }, []);

    const handleSignInClick = useCallback(() => {
        updateView(VIEWS.logInView);
    }, []);

    if (isAuthInProgress) {
        return <Loader loaded={!isAuthInProgress} />;
    }

    const overrideProps = {
        gwLoginComponent: {
            successPath: _.get(state, 'from.pathname') || '/home'
        },
        logInViewContainer: {
            visible: view === VIEWS.logInView
        },
        signUpViewContainer: {
            visible: view === VIEWS.signUpView
        },
        forgotPasswordViewContainer: {
            visible: view === VIEWS.forgotPasswordView
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            onForgotPasswordClick: handleForgotPasswordClick,
            onSignUpClick: handleSignUpClick,
            onSignInClick: handleSignInClick
        }
    };

    const renderedContentFromMetadata = renderContentFromMetadata(
        metadata.pageContent,
        overrideProps,
        resolvers
    );

    return (
        <EntryPageTemplate
            contentToRender={renderedContentFromMetadata}
        />
    );
}

EntryPage.propTypes = {
    location: PropTypes.shape({
        state: PropTypes.shape({})
    })
};

EntryPage.defaultProps = {
    location: {}
};

export default EntryPage;
